//Change isLoggedIn and name according to Redux.

import {
  Avatar,
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useContext } from "react";
import { AppContext } from "../../../../context/AppContext";


const UserButton = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn");   
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) ? JSON.parse(localStorage.getItem("userDetails")) : {};    
  const {deleteAll} = useContext(AppContext)
  const name = userDetails.userid;
  const handleClickOnUserButton = () => {
    if (isLoggedIn) {
      navigate("/");
      console.log('here');
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userDetails");
      localStorage.removeItem("isSeller");
      deleteAll();
      window.location.reload(false);
    }
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      bgColor={"rgb(255,255,255)"}
      _hover={{ bg: "rgb(255,255,255)" }}
      size="xs"
    >
      <div
        _hover={{ textDecoration: "none" }}
      >
        <Menu isOpen={isOpen} isLazy={true} placement="bottom-end">
          <>
            <MenuButton
              fontSize="14px"
              size="sm"
              p={"0px"}
              isActive={isOpen}
              colorScheme="rgb(50,174,177)"
              as={Button}
              color="white"
              onMouseEnter={onOpen}
              onMouseLeave={onClose}
            >
              <Flex align={"center"}>
                <Avatar
                  paddingLeft={"10px"}
                  icon={<FaUserCircle />}
                  bg='"rgb(0,0,0)"'
                  color={"black"}
                  boxSize={"30px"}
                ></Avatar>

                <Text
                  paddingLeft={"5px"}
                  color={"black"}
                  fontSize="14px"
                  fontWeight="semibold"
                  whiteSpace="nowrap"
                >
                  {isLoggedIn ? name : "Sign in / Sign up"}
                </Text>
              </Flex>
            </MenuButton>
            <MenuList onMouseEnter={onOpen} onMouseLeave={onClose}>
              {isLoggedIn? <Link to="/user/dashboard/profile"><MenuItem size='xs' fontSize={'14px'}>Dashboard</MenuItem></Link> : <></>}
              <Link to="/login" onClick={handleClickOnUserButton}><MenuItem size='xs' fontSize={'14px'}>{isLoggedIn? 'Logout' : 'LogIn'}</MenuItem></Link>
            </MenuList>
          </>
        </Menu>
      </div>
    </Box>
  );
};
export default UserButton;
